// Home = featured rail only (no general browse).
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useFeatured } from "../api/hooks.js";
import { FeaturedGrid } from "../components/FeaturedGrid.js";
import { pageVariants } from "@/lib/motion";

export function HomePage() {
  const { t } = useTranslation();
  const { data } = useFeatured();
  // Guard `items` too: `data?.items.filter` only null-checks `data`, so a malformed
  // response (data present, items missing) would throw on `.filter`.
  const liveCount = data?.items?.filter((s) => s.status === "live").length ?? 0;

  return (
    <motion.main
      variants={pageVariants}
      initial="initial"
      animate="enter"
      className="mx-auto max-w-7xl px-4 py-8 sm:py-10"
    >
      <div className="mb-7 flex flex-wrap items-center justify-between gap-4">
        <h1 className="font-display text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
          {t("home.title")}
        </h1>
        {liveCount > 0 && (
          <div className="flex items-center gap-1.5 rounded-full border border-white/[0.08] bg-card/60 px-3.5 py-1.5 text-sm font-medium text-destructive-soft backdrop-blur">
            <span className="h-1.5 w-1.5 animate-livepulse rounded-full bg-destructive" />
            {t("home.liveCount", { count: liveCount })}
          </div>
        )}
      </div>
      <FeaturedGrid />
    </motion.main>
  );
}
